/*
 *
 * editDeveloperPlanReducer reducer
 *
 */
import produce from 'immer';
export var initialState = {
    bundles: false,
    bundles_loading: false,
    discounts: [],
    bundles_error: false,
    updateDevPlan_loading: false,
    updateDevPlan_error: false,
    devPlan: {},
    meta: {},
    organizations: [],
    organizations_loading: false,
    organizations_error: false,
    loading: false,
    error: false,
    devPlan_loading: false,
    devPlan_error: false,
};
function editDeveloperPlanReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        switch (action.type) {
            case 'LOAD_BUNDLES_REQUEST':
                state.bundles_loading = true;
                state.bundles_error = false;
                break;
            case 'LOAD_BUNDLES_SUCCESS':
                state.bundles = action.bundles;
                state.meta = action.meta;
                state.bundles_loading = false;
                state.bundles_error = false;
                break;
            case 'LOAD_BUNDLES_FAILURE':
                state.bundles_loading = false;
                state.bundles_error = true;
                break;
            case 'UPDATE_DEVELOPER_PLAN_REQUEST':
                state.updateDevPlan_loading = true;
                state.updateDevPlan_error = false;
                break;
            case 'UPDATE_DEVELOPER_PLAN_SUCCESS':
                state.devPlan = action.devPlan;
                state.updateDevPlan_loading = false;
                state.updateDevPlan_error = false;
                break;
            case 'UPDATE_DEVELOPER_PLAN_FAILURE':
                state.updateDevPlan_loading = false;
                state.updateDevPlan_error = true;
                break;
            case 'GET_DEVELOPER_PLAN_REQUEST':
                state.devPlan_loading = true;
                state.devPlan_error = false;
                break;
            case 'GET_DEVELOPER_PLAN_SUCCESS':
                state.devPlan = action.devPlan;
                state.devPlan_loading = false;
                state.devPlan_error = false;
                break;
            case 'GET_DEVELOPER_PLAN_FAILURE':
                state.devPlan_loading = false;
                state.devPlan_error = true;
                break;
            case 'LOAD_DISCOUNTS_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'LOAD_DISCOUNTS_SUCCESS':
                state.discounts = action.discounts;
                state.loading = false;
                state.error = false;
                break;
            case 'LOAD_DISCOUNTS_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'LOAD_ORGANIZATIONS_REQUEST':
                state.organizations_loading = true;
                state.organizations_error = false;
                break;
            case 'LOAD_ORGANIZATIONS_SUCCESS':
                state.organizations = action.organizations;
                state.organizations_loading = false;
                state.organizations_error = false;
                break;
            case 'LOAD_ORGANIZATIONS_FAILURE':
                state.organizations_loading = false;
                state.organizations_error = true;
                break;
            default:
                break;
        }
    });
}
export default editDeveloperPlanReducer;
